// import React, { useEffect, useState } from 'react';
// import { mygrouporders, fetchPaymentDetails } from './events/action';
// import {
//  CheckCircleIcon,
//  ChevronDown,
//  ChevronUp,
//  MinusCircleIcon,
//  PackageIcon,
//  ShoppingCart,
//  HomeIcon,
//  Users
// } from 'lucide-react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { VerifyToken } from '../MiddleWare/verifyToken';
// const THIRTY_MINUTES = 30 * 60 * 1000;
// const MyGroupOrders = () => {
//  const [openOrderId, setOpenOrderId] = useState(null);
//  const [OrdersData, setOrderData] = useState([]);
//  const [currentUserId, setCurrentUserId] = useState(null);
//  const [error, setError] = useState(null);
//  const [success, setSuccess] = useState(null);
//  const [customerData, setCustomerData] = useState(null);
//  const [payments, setPayments] = useState([]);
//  const [invoiceRequested, setInvoiceRequested] = useState({});
//  const [invoiceRequestTimes, setInvoiceRequestTimes] = useState({});
//  const navigate = useNavigate();

//  VerifyToken();

//  useEffect(() => {
//  const fetchpayment = async () => {
//  const paymentData = await fetchPaymentDetails();
//  setPayments(paymentData || []);
//  };

//  fetchpayment();
//  }, []);

//  useEffect(() => {
//  // Load invoice request times from localStorage
//  const storedTimes = JSON.parse(localStorage.getItem('groupInvoiceRequestTimes') || '{}');
//  setInvoiceRequestTimes(storedTimes);
//  }, []);

//  const handleInvoiceRequest = async (orderId) => {
//  const currentTime = new Date().getTime();
//  const lastRequestTime = invoiceRequestTimes[orderId] || 0;
//  const timeElapsed = currentTime - lastRequestTime;

//  if (timeElapsed < THIRTY_MINUTES) {
//  const remainingSeconds = Math.ceil((THIRTY_MINUTES - timeElapsed) / 1000);
//  setError(`Please wait for ${remainingSeconds} seconds before requesting another invoice.`);
//  return;
//  }

//  try {
//  const token = localStorage.getItem('token');
//  await axios.post(`${process.env.REACT_APP_URL}/api/processGroupOrder/${orderId}`, 
//  { customerGeneratedId: currentUserId },
//  { headers: { token } }
//  );
 
//  setInvoiceRequested(prev => ({ ...prev, [orderId]: true }));
//  setSuccess(`Invoice has been requested. You will receive it via email shortly.`);
 
//  // Update the request time
//  const newRequestTimes = { ...invoiceRequestTimes, [orderId]: currentTime };
//  setInvoiceRequestTimes(newRequestTimes);
//  localStorage.setItem('groupInvoiceRequestTimes', JSON.stringify(newRequestTimes));

//  // Reset after one minute
//  setTimeout(() => {
//  setInvoiceRequested(prev => ({ ...prev, [orderId]: false }));
//  }, THIRTY_MINUTES);
//  } catch (error) {
//  console.error('Error requesting invoice:', error);
//  setError('Failed to request invoice. Please try again later.');
//  }
//  };

//  const isInvoiceRequestDisabled = (orderId) => {
//  const lastRequestTime = invoiceRequestTimes[orderId] || 0;
//  const timeElapsed = new Date().getTime() - lastRequestTime;
//  return timeElapsed < THIRTY_MINUTES;
//  };
//  const getCurrentUserId = async () => {
//  const token = localStorage.getItem('token');
//  if (!token) {
//  throw new Error('Unauthorized');
//  }
//  const response = await fetch(`${process.env.REACT_APP_URL}/api/user/getuser/${token}`);
//  if (!response.ok) {
//  throw new Error(`HTTP error! status: ${response.status}`);
//  }
 
//  const data = await response.json();
//  return data.customer_generated_id;
//  };


 

//  const fetchCustomerDetails = async () => {
//  try {
//  const response = await fetch(`${process.env.REACT_APP_URL}/api/mycustomers`);
//  if (!response.ok) {
//  throw new Error(`HTTP error! status: ${response.status}`);
//  }

//  const data = await response.json();
//  console.log("customer data", data)
//  setCustomerData(data); // Store in state
//  } catch (error) {
//  console.error('Failed to fetch customer data:', error);
//  }
//  };
//  useEffect(() => {
//  fetchCustomerDetails();
//  }, []);
//  useEffect(() => {
//  const fetchData = async () => {
//  try {
//  const userId = await getCurrentUserId();
//  setCurrentUserId(userId);
//  const orderData = await mygrouporders();
//  console.log("orderdata",orderData)

//  setOrderData(orderData);
//  } catch (error) {
//  console.error("Error fetching data:", error);
//  setError("Failed to load orders");
//  }
//  };
//  fetchData();
//  }, []);
//  console.log("data", OrdersData)
//  const formattedOrders = OrdersData.map((order) => {
//  // Get current user's order details
//  console.log("formatted", OrdersData)
//  const userOrderDetails = order.order_details.filter(
//  detail => detail.customer_generated_id === currentUserId
//  );
//  // Get other users' summary (ID and total amount only)

//  const otherUsersSummary = order.order_details
//  .filter(detail => detail.customer_generated_id !== currentUserId)
//  .map(detail => {

//  return {
//  customer_id: detail.customer_generated_id,
//  total: detail.total_amount
//  };
//  });

//  if (userOrderDetails.length === 0) {
//  return null;
//  }

//  const totalAmount = order.total_amount;
//  const finalinvoicevalue = order.finalinvoicevalue;
//  const discount = order.discount;
//  const paymentDetails = payments.find(payment => payment.paymentid === order.paymentid);
//  const customerInfo = customerData?.find(
//  (customer) => customer.customer_generated_id === order.customer_generated_id
//  );
//  const customerName = customerInfo ? customerInfo.customer_name : `User #${order.customer_generated_id}`;



//  const formattedItems = userOrderDetails.flatMap(detail =>
//  detail.cart_data.map(item => {
//  const amount = item.quantity ? item.quantity * parseFloat(item[item.selectedPack] || 0) : 0;
 
//  return {
//  name: item.ItemName,
//  quantity: item.quantity || 1,
//  amount: amount,
//  discountedAmount: discount ? amount - ((amount * parseFloat(discount)) / 100) : amount,
//  selectedPack: item.selectedPack,
//  delivery_status: order.delivery_status,
//  merchantreferenceid: paymentDetails?.merchantreferenceid || null,
//  phonepereferenceid: paymentDetails?.phonepereferenceid || null,
//  paymenttype: paymentDetails?.paymenttype || null,

 
//  };
//  })
//  );

//  const date = new Date(order.ordered_at);

//  const formattedDate = date.toLocaleDateString('en-GB');

 
//  return {
//  id: order.order_generated_id,
//  amount: totalAmount,
//  items: formattedItems,
//  status: order.delivery_status,
//  date: formattedDate,
//  paidby: customerName,

//  groupCode: order.group_code,
//  otherUsers: otherUsersSummary,
//  discount: discount,
//  finalinvoicevalue: finalinvoicevalue,
//  discountedAmount: discount ? (totalAmount - (totalAmount * parseFloat(discount) / 100)).toFixed(2) : totalAmount,
//  paymentDetails: {
//  merchantreferenceid: paymentDetails?.merchantreferenceid || null,
//  phonepereferenceid: paymentDetails?.phonepereferenceid || null,
//  paymenttype: paymentDetails?.paymenttype || null,
//  },
 
//  };
//  }).filter(Boolean);

//  const handleOrderClick = (order) => {
//  setOpenOrderId(openOrderId === order.id ? null : order.id);
//  };

//  const handleViewHome = () => {
//  const currentOrder = formattedOrders.find(order => order.id === openOrderId);

//  const groupCodeToSet = currentOrder?.groupCode || formattedOrders[0]?.groupCode;

//  if (groupCodeToSet) {
//  localStorage.setItem('groupCode', groupCodeToSet);
//  }

//  const groupcode = localStorage.getItem('groupCode');
//  navigate(`/groups/${groupcode}`);

//  };



//  const renderProgressIcons = (progress) => {
//  const stages = ['Accepted', 'Shipped', 'Delivered'];
//  const activeIndex = stages.indexOf(progress);

//  return (
//  <div className="flex justify-between items-center w-full max-w-md mx-auto mt-2">
//  {stages.map((stage, index) => (
//  <div key={stage} className="flex flex-col items-center relative">
//  {index > 0 && (
//  <div className={`absolute w-full h-0.5 right-1/2 top-3 -z-10 
//  ${index <= activeIndex ? 'bg-green-500' : 'bg-gray-300'}`}
//  />
//  )}
//  {index <= activeIndex ? (
//  <CheckCircleIcon className="text-green-500 h-8 w-8 mb-1 transition-transform duration-200 transform hover:scale-110" />
//  ) : (
//  <MinusCircleIcon className="text-gray-300 h-8 w-8 mb-1 transition-transform duration-200 transform hover:scale-110" />
//  )}
//  <span className={`text-sm font-medium ${index <= activeIndex ? 'text-green-600' : 'text-gray-400'}`}>
//  {stage}
//  </span>
//  </div>
//  ))}
//  </div>
//  );
//  };

//  return (
//  <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50">
//  <div className="bg-gradient-to-r from-red-600 via-orange-500 to-yellow-400 p-8 shadow-lg">
//  <div className="max-w-7xl mx-auto flex items-center justify-between">
//  <HomeIcon
//  className="h-8 w-8 text-white cursor-pointer hover:scale-110 transition-transform"
//  onClick={handleViewHome}
//  />
//  <div className="text-center flex-grow">
//  <h1 className="text-4xl font-bold text-white mb-2">My Group Orders</h1>
//  <p className="text-white text-lg">Track and manage your orders</p>
//  </div>
//  <div className="w-8" />
//  </div>
//  </div>

//  <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
//  {error && (
//  <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded shadow-sm" role="alert">
//  <p className="font-bold">Error</p>
//  <p>{error}</p>
//  </div>
//  )}

//  {success && (
//  <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-6 rounded shadow-sm" role="alert">
//  <p className="font-bold">Success</p>
//  <p>{success}</p>
//  </div>
//  )}

//  <div className="space-y-6">

//  {formattedOrders.length > 0 ? formattedOrders.map((order) => (
//  <div key={order.id}
//  className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl">
//  <div className="p-6 border-b border-gray-100">
//  <div className="flex justify-between items-center">
//  <div className="flex items-center space-x-3">
//  <PackageIcon className="h-6 w-6 text-orange-500" />
//  <div>
//  <h3 className="text-xl font-semibold text-gray-800">Order #{order.id}</h3>
//  <p className="text-sm text-gray-500">Group: {order.groupCode}</p>
//  <p className="text-sm text-gray-500">Date: {order.date}</p>

//  </div>
//  </div>

//  <div className="flex items-center space-x-4">
//  {order.discount ? (
//  <>
//  <div className="flex flex-col items-end">
//  <span className="text-sm text-gray-500">Original Amount:</span>
//  <p className="text-xl font-bold text-orange-600 line-through opacity-75">₹{order.amount}</p>
//  </div>
//  <div className="flex flex-col items-end">
//  <span className="text-sm text-gray-500">After {order.discount}% Discount:</span>
//  <p className="text-xl font-bold text-green-600">₹{order.finalinvoicevalue}</p>
//  </div>
//  </>
//  ) : (
//  <div className="flex flex-col items-end">
//  <span className="text-sm text-gray-500">Total Amount:</span>
//  <p className="text-xl font-bold text-orange-600">₹{order.amount}</p>
//  </div>
//  )}

//  <button
//  onClick={() => handleOrderClick(order)}
//  className="p-2 hover:bg-orange-100 rounded-full transition-colors duration-200"
//  >
//  {openOrderId === order.id ? (
//  <ChevronUp className="h-6 w-6 text-orange-500" />
//  ) : (
//  <ChevronDown className="h-6 w-6 text-orange-500" />
//  )}
//  </button>
//  </div>
//  </div>

//  <div className="mt-6">
//  {renderProgressIcons(order.status)}
//  </div>
//  </div>

//  {openOrderId === order.id && (
//  <div className="bg-orange-50 p-6 border-t border-orange-100">
//  {/* Current User's Items */}

//  {/* Payment Details */}
//  <div className="mb-8">
//  <h4 className="text-lg font-semibold text-gray-800 mb-4">Payment Details</h4>
//  <div className="bg-white p-4 rounded-lg shadow-sm">
//  <p className="text-sm text-gray-600"><strong>Paid By:</strong> {order.paidby} </p>

//  <p className="text-sm text-gray-600"><strong>Payment Type:</strong> {order.paymentDetails?.paymenttype || 'N/A'}</p>
//  <p className="text-sm text-gray-600"><strong>Payment Reference ID:</strong> {order.paymentDetails?.phonepereferenceid || 'N/A'}</p>
//  <p className="text-sm text-gray-600"><strong>Merchant Reference ID:</strong> {order.paymentDetails?.merchantreferenceid || 'N/A'}</p>

//  </div>
//  </div>

//  <div className="mb-8">
//  <h4 className="text-lg font-semibold text-gray-800 mb-4">Your Items</h4>
//  <button
//  onClick={() => handleInvoiceRequest(order.id)}
//  disabled={isInvoiceRequestDisabled(order.id)}
//  className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//  isInvoiceRequestDisabled(order.id)
//  ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
//  : 'bg-orange-500 text-white hover:bg-orange-600'
//  }`}
//  >
//  {isInvoiceRequestDisabled(order.id) ? 'Invoice Requested' : 'Request Invoice'}
//  </button>
//  <div className="grid gap-4 sm:grid-cols-2">

//  {order.items.map((item, index) => (
//  <div key={index}
//  className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
//  <div className="flex justify-between items-start">
//  <div className="space-y-2">
//  <h5 className="font-semibold text-gray-800">{item.name}</h5>
//  <p className="text-sm text-gray-600">Pack: {item.selectedPack}</p>

//  <p className="text-sm text-gray-600">Quantity: {item.quantity}</p>
//  </div>
//  <p className="font-semibold text-orange-600">₹{item.amount}</p>

//  </div>
//  </div>
//  ))}
//  </div>
//  </div>

//  {order.otherUsers.length > 0 && (
//  <div className="mt-6 border-t border-orange-100 pt-6">
//  <div className="flex items-center mb-4">
//  <Users className="h-5 w-5 text-orange-500 mr-2" />
//  <h4 className="text-lg font-semibold text-gray-800">Other Group Members</h4>
//  </div>
//  <div className="bg-white rounded-lg p-4">
//  {order.otherUsers.map((user, index) => {
//  // Find the customer name from customerData
//  const customerInfo = customerData?.find(
//  customer => customer.customer_generated_id === user.customer_id
//  );
//  const customerName = customerInfo ? customerInfo.customer_name : `User #${user.customer_id}`;

 
//  return (
//  <div
//  key={index}
//  className="flex justify-between items-center py-2 border-b last:border-b-0 border-gray-100"
//  >
//  <div className="flex flex-col">
//  <span className="text-gray-800 font-medium">User Name: {customerName}</span>
//  </div>
//  <div className="flex flex-col items-end">
//  {order.discount ? (
//  <>
//  <span className="font-semibold text-gray-500 line-through">
//  Amount: ₹{user.total.toFixed(2)}
//  </span>
//  <span className="font-semibold text-orange-600">
//  Discounted Amount: ₹
//  {(user.total - (user.total * parseFloat(order.discount)) / 100).toFixed(2)}
//  </span>
//  </>
//  ) : (
//  <span className="font-semibold text-orange-600">
//  Amount: ₹{user.total.toFixed(2)}
//  </span>
//  )}
//  </div>
//  </div>
//  );

//  })}
//  </div>
//  </div>
//  )}
//  </div>
//  )}
//  </div>
//  )) : (
//  <div className="text-center py-16 bg-white rounded-xl shadow-md">
//  <PackageIcon className="h-20 w-20 text-gray-400 mx-auto mb-4" />
//  <h3 className="text-xl font-medium text-gray-900 mb-2">No orders found</h3>
//  <p className="text-gray-500 mb-6">Start shopping to see your orders here.</p>
//  <button
//  onClick={handleViewHome}
//  className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-medium rounded-lg hover:bg-orange-600 transition-colors"
//  >
//  <ShoppingCart className="mr-2 h-5 w-5" />
//  Start Shopping
//  </button>
//  </div>
//  )}
//  </div>
//  </div>
//  </div>
//  );
// };

// export default MyGroupOrders;







import React, { useEffect, useState } from 'react';
import { mygrouporders, fetchPaymentDetails } from './events/action';

import {
    CheckCircleIcon,
    ChevronDown,
    ChevronUp,
    MinusCircleIcon,
    PackageIcon,
    ShoppingCart,
    HomeIcon,
    Users
} from 'lucide-react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { VerifyToken } from '../MiddleWare/verifyToken';

const THIRTY_MINUTES = 30 * 60 * 1000;
const MyGroupOrders = () => {
    const [openOrderId, setOpenOrderId] = useState(null);
    const [OrdersData, setOrderData] = useState([]);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [customerData, setCustomerData] = useState(null);
    const [payments, setPayments] = useState([]);
    const [invoiceRequested, setInvoiceRequested] = useState({});
    const [invoiceRequestTimes, setInvoiceRequestTimes] = useState({});
    const [existingGroupCode, setExistingGroupCode] = useState('');
    const [userRole, setUserRole] = useState(null)
    const[Groups,setGroups]=useState([]);
    const navigate = useNavigate();

    VerifyToken();

    useEffect(() => {
        const fetchpayment = async () => {
            const paymentData = await fetchPaymentDetails();
            setPayments(paymentData || []);
        };

        fetchpayment();
    }, []);

    useEffect(() => {
        // Load invoice request times from localStorage
        const storedTimes = JSON.parse(localStorage.getItem('groupInvoiceRequestTimes') || '{}');
        setInvoiceRequestTimes(storedTimes);
    }, []);

    const handleInvoiceRequest = async (orderId) => {
        const currentTime = new Date().getTime();
        const lastRequestTime = invoiceRequestTimes[orderId] || 0;
        const timeElapsed = currentTime - lastRequestTime;

        if (timeElapsed < THIRTY_MINUTES) {
            const remainingSeconds = Math.ceil((THIRTY_MINUTES - timeElapsed) / 1000);
            setError(`Please wait for ${remainingSeconds} seconds before requesting another invoice.`);
            return;
        }

        try {
            const token = localStorage.getItem('token');
            await axios.post(`${process.env.REACT_APP_URL}/api/processGroupOrder/${orderId}`,
                { customerGeneratedId: currentUserId },
                { headers: { token } }
            );

            setInvoiceRequested(prev => ({ ...prev, [orderId]: true }));
            setSuccess(`Invoice has been requested. You will receive it via email shortly.`);

            // Update the request time
            const newRequestTimes = { ...invoiceRequestTimes, [orderId]: currentTime };
            setInvoiceRequestTimes(newRequestTimes);
            localStorage.setItem('groupInvoiceRequestTimes', JSON.stringify(newRequestTimes));

            // Reset after one minute
            setTimeout(() => {
                setInvoiceRequested(prev => ({ ...prev, [orderId]: false }));
            }, THIRTY_MINUTES);
        } catch (error) {
            console.error('Error requesting invoice:', error);
            setError('Failed to request invoice. Please try again later.');
        }
    };

    const isInvoiceRequestDisabled = (orderId) => {
        const lastRequestTime = invoiceRequestTimes[orderId] || 0;
        const timeElapsed = new Date().getTime() - lastRequestTime;
        return timeElapsed < THIRTY_MINUTES;
    };


    const getCurrentUserId = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('Unauthorized');
        }
        const response = await fetch(`${process.env.REACT_APP_URL}/api/user/getuser/${token}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data.customer_generated_id;
    };


    const fetchCustomerDetails = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_URL}/api/mycustomers`);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setCustomerData(data); // Store in state
        } catch (error) {
            console.error('Failed to fetch customer data:', error);
        }
    };
    useEffect(() => {
        fetchCustomerDetails();
    }, []);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const userId = await getCurrentUserId();
                setCurrentUserId(userId);
                const orderData = await mygrouporders();

                setOrderData(orderData);
            } catch (error) {
                console.error("Error fetching data:", error);
                setError("Failed to load orders");
            }
        };
        fetchData();
    }, []);
    const formattedOrders = OrdersData.map((order) => {
        const userOrderDetails = order.order_details.filter(
            detail => detail.customer_generated_id === currentUserId
        );

        const otherUsersSummary = order.order_details
            .filter(detail => detail.customer_generated_id !== currentUserId)
            .map(detail => {

                return {
                    customer_id: detail.customer_generated_id,
                    total: detail.total_amount
                };
            });

        if (userOrderDetails.length === 0) {
            return null;
        }

        const totalAmount = order.total_amount;
        const finalinvoicevalue = order.finalinvoicevalue;
        const discount = order.discount;
        const paymentDetails = payments.find(payment => payment.paymentid === order.paymentid);
        const customerInfo = customerData?.find(
            (customer) => customer.customer_generated_id === order.customer_generated_id
        );
        const customerName = customerInfo ? customerInfo.customer_name : `User #${order.customer_generated_id}`;



        const formattedItems = userOrderDetails.flatMap(detail =>
            detail.cart_data.map(item => {
                const amount = item.quantity ? item.quantity * parseFloat(item[item.selectedPack] || 0) : 0;

                return {
                    name: item.ItemName,
                    quantity: item.quantity || 1,
                    amount: amount,
                    discountedAmount: discount ? amount - ((amount * parseFloat(discount)) / 100) : amount,
                    selectedPack: item.selectedPack,
                    delivery_status: order.delivery_status,
                    merchantreferenceid: paymentDetails?.merchantreferenceid || null,
                    phonepereferenceid: paymentDetails?.phonepereferenceid || null,
                    paymenttype: paymentDetails?.paymenttype || null,


                };
            })
        );

        const date = new Date(order.ordered_at);

        const formattedDate = date.toLocaleDateString('en-GB');


        return {
            id: order.order_generated_id,
            amount: totalAmount,
            items: formattedItems,
            status: order.delivery_status,
            date: formattedDate,
            paidby: customerName,

            groupCode: order.group_code,
            otherUsers: otherUsersSummary,
            discount: discount,
            finalinvoicevalue: finalinvoicevalue,
            discountedAmount: discount ? (totalAmount - (totalAmount * parseFloat(discount) / 100)).toFixed(2) : totalAmount,
            paymentDetails: {
                merchantreferenceid: paymentDetails?.merchantreferenceid || null,
                phonepereferenceid: paymentDetails?.phonepereferenceid || null,
                paymenttype: paymentDetails?.paymenttype || null,
            },

        };
    }).filter(Boolean);

    const handleOrderClick = (order) => {
        setOpenOrderId(openOrderId === order.id ? null : order.id);
    };

useEffect(() => {
    checkUserGroup();
    }, );





    const checkUserGroup = async () => {
        try {
            const userId = await getCurrentUserId();

            // Fetch all groups
            const response = await axios.get(`${process.env.REACT_APP_URL}/api/fetchgroups`);
            setGroups(response.data || []);

            // Find the user's group
            const userGroup = response.data?.find(group =>
                group.groupmembers.some(member =>
                    member.customer_generated_id === userId
                )
            );

            if (userGroup) {
                // Set existing group code
                setExistingGroupCode(userGroup.groupcode);
                // Set user role from the group
                const role = userGroup.groupmembers.find(
                    member => member.customer_generated_id === userId
                )?.role;
                setUserRole(role);
            }
        } catch (error) {
            console.error('Error checking user group:', error);
        }
    };





    const handleViewHome = async () => {
     
        const response = await axios.get(`${process.env.REACT_APP_URL}/api/fetchgroups`);
        const groups = response.data || [];
        const token = await localStorage.getItem('token');
        const userResponse = await axios.get(`${process.env.REACT_APP_URL}/api/user/getuser/${token}`);
        const userId = userResponse.data.customer_generated_id;
        const userGroup = groups.find(group => group.groupcode === existingGroupCode);
         const groupcode=userGroup.groupcode;
         console.log("hii",groupcode);
        navigate(`/groups/${groupcode}`);

    };
    const renderProgressIcons = (progress) => {
        const stages = ['Accepted', 'Shipped', 'Delivered'];
        const activeIndex = stages.indexOf(progress);

        return (
            <div className="flex justify-between items-center w-full max-w-md mx-auto mt-2">
                {stages.map((stage, index) => (
                    <div key={stage} className="flex flex-col items-center relative">
                        {index > 0 && (
                            <div className={`absolute w-full h-0.5 right-1/2 top-3 -z-10 
 ${index <= activeIndex ? 'bg-green-500' : 'bg-gray-300'}`}
                            />
                        )}
                        {index <= activeIndex ? (
                            <CheckCircleIcon className="text-green-500 h-8 w-8 mb-1 transition-transform duration-200 transform hover:scale-110" />
                        ) : (
                            <MinusCircleIcon className="text-gray-300 h-8 w-8 mb-1 transition-transform duration-200 transform hover:scale-110" />
                        )}
                        <span className={`text-sm font-medium ${index <= activeIndex ? 'text-green-600' : 'text-gray-400'}`}>
                            {stage}
                        </span>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50">
            <div className="bg-gradient-to-r from-red-600 via-orange-500 to-yellow-400 p-8 shadow-lg">
                <div className="max-w-7xl mx-auto flex items-center justify-between">
                    <HomeIcon
                        className="h-8 w-8 text-white cursor-pointer hover:scale-110 transition-transform"
                        onClick={handleViewHome}
                    />
                    <div className="text-center flex-grow">
                        <h1 className="text-4xl font-bold text-white mb-2">My Group Orders</h1>
                        <p className="text-white text-lg">Track and manage your orders</p>
                    </div>
                    <div className="w-8" />
                </div>
            </div>

            <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
                {error && (
                    <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded shadow-sm" role="alert">
                        <p className="font-bold">Error</p>
                        <p>{error}</p>
                    </div>
                )}

                {success && (
                    <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-6 rounded shadow-sm" role="alert">
                        <p className="font-bold">Success</p>
                        <p>{success}</p>
                    </div>
                )}

                <div className="space-y-6">

                    {formattedOrders.length > 0 ? formattedOrders.map((order) => (
                        <div key={order.id}
                            className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl">
                            <div className="p-6 border-b border-gray-100">
                                <div className="flex justify-between items-center">
                                    <div className="flex items-center space-x-3">
                                        <PackageIcon className="h-6 w-6 text-orange-500" />
                                        <div>
                                            <h3 className="text-xl font-semibold text-gray-800">Order #{order.id}</h3>
                                            <p className="text-sm text-gray-500">Group: {order.groupCode}</p>
                                            <p className="text-sm text-gray-500">Date: {order.date}</p>

                                        </div>
                                    </div>

                                    <div className="flex items-center space-x-4">
                                        {order.discount ? (
                                            <>
                                                <div className="flex flex-col items-end">
                                                    <span className="text-sm text-gray-500">Original Amount:</span>
                                                    <p className="text-xl font-bold text-orange-600 line-through opacity-75">₹{order.amount}</p>
                                                </div>
                                                <div className="flex flex-col items-end">
                                                    <span className="text-sm text-gray-500">After {order.discount}% Discount:</span>
                                                    <p className="text-xl font-bold text-green-600">₹{order.finalinvoicevalue}</p>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="flex flex-col items-end">
                                                <span className="text-sm text-gray-500">Total Amount:</span>
                                                <p className="text-xl font-bold text-orange-600">₹{order.amount}</p>
                                            </div>
                                        )}

                                        <button
                                            onClick={() => handleOrderClick(order)}
                                            className="p-2 hover:bg-orange-100 rounded-full transition-colors duration-200"
                                        >
                                            {openOrderId === order.id ? (
                                                <ChevronUp className="h-6 w-6 text-orange-500" />
                                            ) : (
                                                <ChevronDown className="h-6 w-6 text-orange-500" />
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="mt-6">
                                    {renderProgressIcons(order.status)}
                                </div>
                            </div>

                            {openOrderId === order.id && (
                                <div className="bg-orange-50 p-6 border-t border-orange-100">
                                    {/* Current User's Items */}

                                    {/* Payment Details */}
                                    <div className="mb-8">
                                        <h4 className="text-lg font-semibold text-gray-800 mb-4">Payment Details</h4>
                                        <div className="bg-white p-4 rounded-lg shadow-sm">
                                            <p className="text-sm text-gray-600"><strong>Paid By:</strong> {order.paidby} </p>

                                            <p className="text-sm text-gray-600"><strong>Payment Type:</strong> {order.paymentDetails?.paymenttype || 'N/A'}</p>
                                            <p className="text-sm text-gray-600"><strong>Payment Reference ID:</strong> {order.paymentDetails?.phonepereferenceid || 'N/A'}</p>
                                            <p className="text-sm text-gray-600"><strong>Merchant Reference ID:</strong> {order.paymentDetails?.merchantreferenceid || 'N/A'}</p>

                                        </div>
                                    </div>

                                    <div className="mb-8">
                                        <h4 className="text-lg font-semibold text-gray-800 mb-4">Your Items</h4>
                                        <button
                                            onClick={() => handleInvoiceRequest(order.id)}
                                            disabled={isInvoiceRequestDisabled(order.id)}
                                            className={`px-4 py-2 rounded-lg font-medium transition-colors ${isInvoiceRequestDisabled(order.id)
                                                    ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                                    : 'bg-orange-500 text-white hover:bg-orange-600'
                                                }`}
                                        >
                                            {isInvoiceRequestDisabled(order.id) ? 'Invoice Requested' : 'Request Invoice'}
                                        </button>
                                        <div className="grid gap-4 sm:grid-cols-2">

                                            {order.items.map((item, index) => (
                                                <div key={index}
                                                    className="bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
                                                    <div className="flex justify-between items-start">
                                                        <div className="space-y-2">
                                                            <h5 className="font-semibold text-gray-800">{item.name}</h5>
                                                            <p className="text-sm text-gray-600">Pack: {item.selectedPack}</p>

                                                            <p className="text-sm text-gray-600">Quantity: {item.quantity}</p>
                                                        </div>
                                                        <p className="font-semibold text-orange-600">₹{item.amount}</p>

                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {order.otherUsers.length > 0 && (
                                        <div className="mt-6 border-t border-orange-100 pt-6">
                                            <div className="flex items-center mb-4">
                                                <Users className="h-5 w-5 text-orange-500 mr-2" />
                                                <h4 className="text-lg font-semibold text-gray-800">Other Group Members</h4>
                                            </div>
                                            <div className="bg-white rounded-lg p-4">
                                                {order.otherUsers.map((user, index) => {
                                                    // Find the customer name from customerData
                                                    const customerInfo = customerData?.find(
                                                        customer => customer.customer_generated_id === user.customer_id
                                                    );
                                                    const customerName = customerInfo ? customerInfo.customer_name : `User #${user.customer_id}`;


                                                    return (
                                                        <div
                                                            key={index}
                                                            className="flex justify-between items-center py-2 border-b last:border-b-0 border-gray-100"
                                                        >
                                                            <div className="flex flex-col">
                                                                <span className="text-gray-800 font-medium">User Name: {customerName}</span>
                                                            </div>
                                                            <div className="flex flex-col items-end">
                                                                {order.discount ? (
                                                                    <>
                                                                        <span className="font-semibold text-gray-500 line-through">
                                                                            Amount: ₹{user.total.toFixed(2)}
                                                                        </span>
                                                                        <span className="font-semibold text-orange-600">
                                                                            Discounted Amount: ₹
                                                                            {(user.total - (user.total * parseFloat(order.discount)) / 100).toFixed(2)}
                                                                        </span>
                                                                    </>
                                                                ) : (
                                                                    <span className="font-semibold text-orange-600">
                                                                        Amount: ₹{user.total.toFixed(2)}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );

                                                })}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )) : (
                        <div className="text-center py-16 bg-white rounded-xl shadow-md">
                            <PackageIcon className="h-20 w-20 text-gray-400 mx-auto mb-4" />
                            <h3 className="text-xl font-medium text-gray-900 mb-2">No orders found</h3>
                            <p className="text-gray-500 mb-6">Start shopping to see your orders here.</p>
                            <button
                                onClick={handleViewHome}
                                className="inline-flex items-center px-6 py-3 bg-orange-500 text-white font-medium rounded-lg hover:bg-orange-600 transition-colors"
                            >
                                <ShoppingCart className="mr-2 h-5 w-5" />
                                Start Shopping
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MyGroupOrders;



















